export default "__VITE_ASSET__95fd2ecf__"